export const initialPaginationMetadata = {
  totalCount: 0,
  totalPages: 0,
  currentPage: 1,
}
